import React from 'react';
import { motion } from 'framer-motion';
import { FiPlus, FiCheck, FiInfo, FiChevronRight, FiMinus } from 'react-icons/fi';
import { useSolution } from '../../context/SolutionContext';
import Tooltip from '../ui/Tooltip';

const ComponentCard = ({ component, isSelected, compatibilityScore }) => {
  const { state, dispatch } = useSolution();
  
  const selectedComponent = state.selectedComponents.find(c => c.id === component.id);
  const quantity = selectedComponent?.quantity || 0;
  
  const handleAdd = () => {
    dispatch({ type: 'ADD_COMPONENT', payload: component });
  };
  
  const handleRemove = () => {
    dispatch({ type: 'REMOVE_COMPONENT', payload: component });
  };
  
  const handleIncrement = () => {
    dispatch({ type: 'INCREMENT_QUANTITY', payload: { id: component.id } });
  };
  
  const handleDecrement = () => {
    dispatch({ type: 'DECREMENT_QUANTITY', payload: { id: component.id } });
  };
  
  const handleShowDetail = () => {
    dispatch({ type: 'SHOW_COMPONENT_DETAIL', payload: component });
  };
  
  return (
    <motion.div
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
      className={`relative p-4 rounded-xl border transition-all cursor-pointer ${
        isSelected
          ? 'border-green-500 bg-green-50 shadow-lg'
          : 'border-gray-200 bg-white hover:border-blue-400 hover:shadow-md'
      }`}
    >
      <div className="flex items-start justify-between">
        <div className="flex items-center gap-3 flex-1">
          <span className="text-2xl">{component.icon}</span>
          <div className="flex-1">
            <h4 className="font-semibold text-gray-900">{component.name}</h4>
            
            {/* Breadcrumb */}
            <div className="flex items-center gap-1 mt-1 text-xs text-gray-500 flex-wrap">
              <span className="text-blue-600">{component.phaseName}</span>
              <FiChevronRight className="w-3 h-3 text-gray-400" />
              <span className="text-yellow-600">{component.layerName}</span>
              <FiChevronRight className="w-3 h-3 text-gray-400" />
              <span className="text-pink-600">{component.subLayerName}</span>
            </div>
            
            <p className="text-xs text-gray-500 mt-1">{component.purpose}</p>
          </div>
        </div>
        
        <div className="flex items-center gap-2">
          <Tooltip content="View details">
            <button
              onClick={handleShowDetail}
              className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
            >
              <FiInfo className="w-4 h-4 text-gray-500" />
            </button>
          </Tooltip>
          
          {!isSelected ? (
            <button
              onClick={handleAdd}
              className="p-2 rounded-lg transition-colors bg-gray-100 hover:bg-blue-100 text-gray-600 hover:text-blue-600"
            >
              <FiPlus className="w-4 h-4" />
            </button>
          ) : (
            <div className="flex items-center gap-1">
              <button
                onClick={handleDecrement}
                className="p-1 bg-gray-100 hover:bg-gray-200 rounded text-gray-600"
              >
                <FiMinus className="w-3 h-3" />
              </button>
              <span className="px-2 py-1 bg-green-100 text-green-700 rounded font-semibold text-sm min-w-[30px] text-center">
                {quantity}
              </span>
              <button
                onClick={handleIncrement}
                className="p-1 bg-green-500 hover:bg-green-600 rounded text-white"
              >
                <FiPlus className="w-3 h-3" />
              </button>
            </div>
          )}
        </div>
      </div>
      
      <div className="mt-3 flex items-center justify-between text-xs text-gray-500">
        <span>${component.cost?.low || 0} - ${component.cost?.high || 0} {component.cost?.unit || ''}</span>
        {isSelected && (
          <span className="text-green-600 font-semibold">
            Total: ${((component.cost?.low || 0) * quantity).toFixed(0)} - ${((component.cost?.high || 0) * quantity).toFixed(0)}
          </span>
        )}
      </div>
    </motion.div>
  );
};

export default ComponentCard;